<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   [tooltip]="panelTitle$ | async"
                   icon="components_drawing"></tm-menubar-button>
